import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { WorkingTimes } from '../../../../common/types';
import { DAYS_OF_THE_WEEK } from '../../../../common/ui/constants.tsx';
import { Header } from '../../../../common/ui/styled';
import { DayWithHours } from './main';
import messages from './messages';

type WorkWeekViewProps = {
	workingTimes: WorkingTimes;
} & Intl;

const WorkWeekView = ({ intl: { formatMessage }, workingTimes }: WorkWeekViewProps) => {
	if (!workingTimes) {
		return null;
	}

	return (
		<>
			<Header>
				{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
				<h2> {formatMessage(messages.workingTimesHeader)} </h2>
			</Header>
			<WorkingTimesGrid>
				{DAYS_OF_THE_WEEK.map((day) => (
					<DayWithHours key={day} day={day} defaultWorkingTimes={workingTimes[day]} />
				))}
			</WorkingTimesGrid>
		</>
	);
};

export const WorkWeek = injectIntl(WorkWeekView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WorkingTimesGrid = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.DN0),
	marginTop: token('space.100', '8px'),
});
